import { Link } from '@tanstack/react-router';
import { ShieldX } from 'lucide-react';

import { Button } from '~/components/ui/button';

interface AccessDeniedProps {
  /** Optional reason override for the explanatory body copy. */
  reason?: string;
  /** Where the "Go to Dashboard" link points. Defaults to root. */
  homeTo?: string;
}

/**
 * Generic full-page "Access Denied" view used by route guards (feature-gate
 * misses, permission misses) and by inline screen guards. Centralised here so
 * every gate produces the same visual message and dashboard escape hatch.
 */
export function AccessDenied({ reason, homeTo = '/' }: AccessDeniedProps) {
  return (
    <div className="bg-gradient-page flex h-full min-h-[60vh] flex-col items-center justify-center gap-4 p-8 text-center">
      <ShieldX className="text-muted-foreground h-12 w-12" aria-hidden="true" />
      <div className="space-y-1.5">
        <h1 className="text-2xl font-semibold tracking-tight">Access Denied</h1>
        <p className="text-muted-foreground max-w-md text-sm">
          {reason ??
            'You don’t have access to this page. The feature may be disabled, or your role may not have permission to view it.'}
        </p>
      </div>
      <Button asChild className="cursor-pointer">
        <Link to={homeTo}>Go to home</Link>
      </Button>
    </div>
  );
}
